<template>
  <nav class="bottom-navigation">
    <div class="nav-container">
      <div class="nav-items">
        <!-- 首頁 -->
        <router-link to="/" class="nav-item" :class="{ active: $route.path === '/' }">
          <div class="nav-icon-wrap">
            <svg class="nav-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
          </div>
          <span class="nav-label">{{ $t('bottomNav.首页') }}</span>
        </router-link>

        <!-- 閃期權 -->
        <router-link to="/flash-options" class="nav-item" :class="{ active: $route.path === '/flash-options' }">
          <div class="nav-icon-wrap">
            <svg class="nav-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
            </svg>
          </div>
          <span class="nav-label">{{ $t('bottomNav.闪期权') }}</span>
        </router-link>

        <!-- 個人中心 -->
        <router-link to="/assets" class="nav-item" :class="{ active: $route.path === '/assets' }">
          <div class="nav-icon-wrap">
            <svg class="nav-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
          </div>
          <span class="nav-label">{{ $t('assets.我的账户') || $t('bottomNav.资产') }}</span>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
  name: 'BottomNavigation',
  setup() {
    const { t } = useI18n()
    return { t }
  }
}
</script>

<style scoped>
.bottom-navigation {
  position: fixed;
  bottom: 14px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 24px);
  max-width: 600px;
  z-index: 1000;
  padding: 0;
}

.nav-container {
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(14px);
  border: 1px solid #dce1e8;
  border-radius: 18px;
  padding: 8px 10px calc(8px + env(safe-area-inset-bottom));
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.nav-items {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 2px;
}

.nav-item {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  text-decoration: none;
  padding: 8px 2px 7px;
  border-radius: 12px;
  transition: all 0.22s ease;
  background: transparent;
  border: 1px solid transparent;
  min-height: 58px;
  min-width: 0;
  overflow: hidden;
}

.nav-item:hover {
  background: rgba(46, 125, 50, 0.06);
}

.nav-icon-wrap {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.nav-icon-svg {
  width: 20px;
  height: 20px;
  color: #90a4ae;
}

.nav-item .nav-label {
  font-size: 10px;
  font-weight: 600;
  color: #78909c;
  letter-spacing: 0;
  text-align: center;
  line-height: 1.25;
  max-width: 100%;
  word-break: break-word;
  overflow-wrap: break-word;
}

.nav-item.active {
  background: #e8f5e9;
  border-color: #a5d6a7;
}

.nav-item.active:hover {
  background: #c8e6c9;
}

.nav-item.active .nav-icon-svg {
  color: #2e7d32;
}

.nav-item.active .nav-label {
  color: #2e7d32;
}

@media (max-width: 480px) {
  .bottom-navigation {
    bottom: 10px;
    width: calc(100% - 16px);
  }

  .nav-container {
    border-radius: 16px;
    padding: 7px 8px calc(7px + env(safe-area-inset-bottom));
  }

  .nav-items {
    gap: 1px;
  }

  .nav-item {
    min-height: 54px;
    padding: 7px 1px 6px;
  }

  .nav-icon-wrap {
    width: 24px;
    height: 24px;
  }

  .nav-icon-svg {
    width: 18px;
    height: 18px;
  }

  .nav-item .nav-label {
    font-size: 9px;
  }
}

@media (max-width: 360px) {
  .nav-item .nav-label {
    font-size: 8px;
  }
}

@media (min-width: 769px) {
  .bottom-navigation {
    display: none;
  }
}
</style>
